export default "__VITE_ASSET__ff07c140__"